/** Icon-only action buttons (lock, pause, resume). */
export const assignActionIconButtonSize = 36;

/** Shared MUI sx presets for assign-prescription action buttons */
export const assignActionButtonBase = {
  textTransform: 'none',
  fontWeight: 600,
  fontSize: '0.78rem',
  borderRadius: '10px',
  px: 1.75,
  py: 0.7,
  minHeight: 36,
  letterSpacing: '0.01em',
  lineHeight: 1.25,
  whiteSpace: 'nowrap',
  border: 'none',
  boxShadow: '0 1px 3px rgba(15, 23, 42, 0.12)',
  '&.Mui-disabled': {
    opacity: 1,
  },
};

const solidDisabled = {
  background: '#e2e8f0 !important',
  color: '#94a3b8 !important',
  boxShadow: 'none !important',
  opacity: 1,
};

const primaryDisabled = {
  background: '#7dd3fc !important',
  color: '#ffffff !important',
  boxShadow: 'none !important',
  opacity: 1,
};

const solidVariant = (
  bg,
  hover,
  hoverShadow = '0 2px 8px rgba(15, 23, 42, 0.2)',
  disabled = solidDisabled
) => ({
  ...assignActionButtonBase,
  background: bg,
  color: '#fff',
  '&:hover': {
    background: hover,
    boxShadow: hoverShadow,
  },
  '&:disabled': disabled,
  '&.Mui-disabled': disabled,
});

export const assignActionButtonVariants = {
  /** Save / primary workflow — match licensing cyan */
  primary: solidVariant(
    '#00a7e1',
    '#0096cc',
    '0 8px 18px rgba(0, 167, 225, 0.32)',
    primaryDisabled
  ),
  savePrint: solidVariant(
    '#0284c7',
    '#0369a1',
    '0 8px 18px rgba(2, 132, 199, 0.32)',
    primaryDisabled
  ),
  /** Neutral utilities */
  neutral: solidVariant('#64748b', '#475569'),
  utility: solidVariant('#546e7a', '#455a64'),
  /** Print & documents */
  print: solidVariant('#1e3a5f', '#152a45'),
  printLabel: solidVariant('#1565c0', '#0d47a1'),
  /** Patient communication */
  remind: solidVariant('#b45309', '#92400e'),
  consult: solidVariant('#0c4a6e', '#082f49'),
  pickup: solidVariant('#1d4ed8', '#1e40af'),
  /** Order state */
  hold: solidVariant('#607d8b', '#546e7a'),
  resume: solidVariant('#0284c7', '#0369a1'),
  /** Destructive */
  danger: solidVariant('#c62828', '#b71c1c'),
  remove: solidVariant('#8e2430', '#6d1b26'),
  /** Bin activate (positive) — blue, not green */
  success: solidVariant('#2563eb', '#1d4ed8'),
  /** Lock icon */
  icon: {
    minWidth: assignActionIconButtonSize,
    width: assignActionIconButtonSize,
    height: assignActionIconButtonSize,
    borderRadius: '10px',
    p: 0,
    border: 'none',
    background: '#37474f',
    color: '#fff',
    boxShadow: '0 1px 3px rgba(15, 23, 42, 0.12)',
    '&:hover': {
      background: '#263238',
    },
    '&:disabled': solidDisabled,
    '&.Mui-disabled': solidDisabled,
  },
  /** @deprecated aliases — map to distinct colors in callers */
  secondary: solidVariant('#64748b', '#475569'),
  accent: solidVariant('#1d4ed8', '#1e40af'),
  info: solidVariant('#1565c0', '#0d47a1'),
};

export const getAssignActionButtonSx = (variant = 'neutral') =>
  assignActionButtonVariants[variant] || assignActionButtonVariants.neutral;

/** Tooltips: use readable casing when the label is ALL CAPS (button text unchanged). */
export const formatAssignActionTooltip = (text) => {
  if (text == null || typeof text !== 'string') return text;
  const trimmed = text.trim();
  if (!trimmed) return trimmed;
  const letters = trimmed.replace(/[^a-zA-Z]/g, '');
  if (!letters || letters !== letters.toUpperCase()) {
    return trimmed;
  }
  return trimmed.toLowerCase().replace(/\b[a-z]/g, (char) => char.toUpperCase());
};



// WEBPACK FOOTER //
// ./src/components/assign-prescriptions/assignActionButtonStyles.js